import { LocationsApi } from "../../Api/LocationsApi";
import { NewTreatmentsApi } from "../../Api/TreatmentsApi";
import { DoctorsApi } from "../../Api/DoctorsApi";
import { BookingApi } from "../../Api/BookingApi";
import { doctorInitialState } from "../Helpers/initialState/doctorInitialState";
import { locationInitialState } from "../Helpers/initialState/locationInitialState";
import { getServiceContainersFromTreatments } from "../Helpers/treatmentsHelpers";
import { BookingLabelsDto } from "@apiModels/BookingLabelsDto.csharp";

const servicesApi = new NewTreatmentsApi();
const locationApi = new LocationsApi();
const doctorsApi = new DoctorsApi();
const bookingApi = new BookingApi();

export async function getRootData(bookingLabels: BookingLabelsDto | undefined) {
  const [treatmentsResponse, locationsResponse, doctorsResponse] =
    await Promise.all([
      servicesApi.getTreatments(),
      locationApi.get(),
      doctorsApi.get(),
    ]);
  const commonLabels = bookingLabels!.commonLabels;

  const allCenters = {
    ...locationInitialState,
    id: "-1",
    name: commonLabels.placeDropdownPlaceholder,
    supportsOnlineBooking: true,
    centers: locationsResponse
      .filter((c) => c.isLocation == false)
      .map((c) => c.id),
    isLocation: true,
  };
  locationsResponse.unshift(allCenters);

  const services = getServiceContainersFromTreatments(treatmentsResponse);

  const initialDoctor = {
    ...doctorInitialState,
    id: "-1",
    name: "Vis alle behandlere",
    centers: allCenters.centers,
    services: services.map((s) => s.id),
  };
  doctorsResponse.unshift(initialDoctor);

  return {
    treatments: treatmentsResponse,
    services: services,
    centers: locationsResponse,
    doctors: doctorsResponse,
  };
}

export async function useThirdStepSubmit(request: any) {
  return await bookingApi.create(request);
}

export async function useThirdStepSubmitMetodika(request: any) {
  return await bookingApi.createMetodika(request);
}

export async function useThirdStepDropInSubmit(request: any) {
  return await bookingApi.dropIn(request);
}

export async function useThirdStepDropInMetodikaSubmit(request: any) {
    return await bookingApi.dropInMetodika(request);
}

export async function useThirdStepConfirm(request: any) {
  return await bookingApi.confirm(request);
}
